<app-report-helper #printHelper></app-report-helper>
<div style="height: 100%;width: 100%;display: flex;flex-direction: column;">
    <div>{{env}}</div>
    <div>{{loginMsg}}</div>
    <div>{{localConnection}}</div>
    <div>{{localMsg}}</div>
    <div>{{serverConnection}}</div>
    <div style="flex-grow: 1;overflow: auto;">
        <div *ngFor="let item of logs">{{item}}</div>
    </div>
</div>
